module.exports = __webpack_public_path__ + "img/highwayPatrol.4e00c530.png";